import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { REWARD_BASE_URL } from "configs/AppConfig";
import axiosHttp from "services/axiosHttp";

export const createSupplierPayment = createAsyncThunk("createSupplierPayment", async ({ channelId, grnId, payload }, { rejectWithValue }) => {
	try {
		const url = `${REWARD_BASE_URL}backoffice/channel/${channelId}/supplier-payement/${grnId}`;
		console.log(url, payload, channelId, grnId);
		const response = await axiosHttp.post(url, payload);
		return response.data;
	} catch (err) {
		if (!err.response) throw err;
		return rejectWithValue(err.response.data);
	}
});

const SupplierPaymentCreateSlice = createSlice({
	name: "SupplierPaymentCreateSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},
	reducers: {
		resetSupplierPaymentCreateState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(createSupplierPayment.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});
		builder.addCase(createSupplierPayment.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});
		builder.addCase(createSupplierPayment.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetSupplierPaymentCreateState } = SupplierPaymentCreateSlice.actions;
export default SupplierPaymentCreateSlice.reducer;
